<template>
  <div class="order-container">
    <div class="order-header">
      <div class="rest-name-section">
        <span class="order-name">{{ order.restaurantName }}</span>
        <a class="order-action" :href="order.restMenuUrl" :aria-label="`Add More Items from ${order.restaurantName}`">
          <icon-base width="12" height="12" class="order-action-icon" :iconName="'Add Items'">
            <icon-plus-circle />
          </icon-base>
          <span class="order-action-text">Add More Items</span>
        </a>
      </div>
      <button
        class="clear-all-section"
        :aria-label="`Clear all ${order.restaurantName} items from cart.`"
        @click.prevent="$emit('clear-order', order.id)"
        @keyup.enter="$emit('clear-order', order.id)"
      >
        <i class="fas fa-trash fa-lg"></i>
        Clear All
      </button>
    </div>

    <cart-items
      :items="order.items"
      :restId="order.id"
      @edit-item="handleEditItem"
      @remove-item="handleRemove"
      @edit-item-qty="handleEditItemQty"
      @close-cart="$emit('close-cart')"
    />
    <cart-instructions
      v-if="showStaffCartInfo"
      :specialInstructions="order.specialInstructions"
      :restId="order.id"
      :label="'Special Instructions for ' + order.restaurantName"
      :disabledLabel="order.restaurantName + ' does not allow Special Instructions at this time'"
      :allowOrderNotes="order.allowOrderNotes"
      :placeholder="'Dressing on the side'"
      @updateRestComment="handleUpdateRestComment"
    ></cart-instructions>
  </div>
</template>

<script>
import CartItems from './CartItems.vue'

import IconBase from '../IconBase.vue'

import IconPlusCircle from '../icons/IconPlusCircle.vue'
import CartInstructions from './CartInstructions.vue'

export default {
  name: 'CartOrders',
  components: {
    CartItems,
    IconBase,
    IconPlusCircle,
    CartInstructions,
  },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    showStaffCartInfo: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleEditItem(payload) {
      this.$emit('edit-item', payload)
    },
    handleRemove(payload) {
      this.$emit('remove-item', payload)
    },
    handleEditItemQty(payload) {
      this.$emit('edit-item-qty', payload)
    },
    handleUpdateRestComment(payload) {
      this.$emit('updateRestComment', payload)
    },
  },
}
</script>

<style lang="scss" scoped>
.order-header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 10px;
}

.rest-name-section {
  display: flex;
  flex-direction: column;
}

.clear-all-section {
  font-size: 12px !important;
  font-weight: 900;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 66px;
  &:hover,
  &:focus {
    text-decoration: underline;
    cursor: pointer;
    color: $red;
  }
}

.order-name {
  font-size: 1.5rem;
  font-weight: 700;
}

.order-action {
  @include transition(color);
  font-weight: 700;
  font-size: 1.2rem;
  text-decoration: none;
  color: $tomato;
  display: flex;
  align-items: center;

  &:hover,
  &:focus {
    color: $royal;
    text-decoration: underline;
  }
}

.order-action-icon {
  color: $tomato;
  margin-right: 5px;
}

.order-container {
  margin: 0 5px;
}
</style>
